module.exports = __webpack_public_path__ + "img/project-letter--legacy.a4eda622.png";